module.exports = __webpack_public_path__ + "static/img/mines-logo.6501311.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mines-logo.png
// module id = 3Sw7
// module chunks = 1